import React, { useEffect, useState } from 'react';
import { portfolioApi } from '../services/api';

interface Portfolio {
  id: number;
  user: string;
  portfolioName: string;
  cost: string | null;
  balance: string | null;
  cap: string | null;
  comment: string | null;
  active: boolean | null;
}

const PortfoliosPage: React.FC = () => {
  const [portfolios, setPortfolios] = useState<Portfolio[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    portfolioApi
      .list()
      .then((res) => setPortfolios(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={styles.container}>
      <h4 style={styles.heading}>Portfolios</h4>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '2em' }}>Loading...</div>
      ) : (
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Name</th>
              <th style={styles.th}>Cost</th>
              <th style={styles.th}>Balance</th>
              <th style={styles.th}>Capital</th>
              <th style={styles.th}>Active</th>
              <th style={styles.th}>Comment</th>
            </tr>
          </thead>
          <tbody>
            {portfolios.map((p, idx) => {
              const cost = parseFloat(p.cost || '0');
              const balance = parseFloat(p.balance || '0');
              const cap = parseFloat(p.cap || '0');
              const rowBg = idx % 2 === 0 ? '#fff' : '#e6f2ff';
              return (
                <tr key={p.id} style={{ backgroundColor: rowBg }}>
                  <td style={styles.td}><strong>{p.portfolioName}</strong></td>
                  <td style={{ ...styles.td, textAlign: 'right' }}>{cost.toFixed(2)}</td>
                  <td style={{ ...styles.td, textAlign: 'right' }}>{balance.toFixed(2)}</td>
                  <td style={{ ...styles.td, textAlign: 'right' }}>{cap.toFixed(2)}</td>
                  <td style={{ ...styles.td, textAlign: 'center' }}>{p.active ? 'Yes' : 'No'}</td>
                  <td style={styles.td}>{p.comment || '-'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    padding: '1em 0.5em',
    backgroundColor: '#fff',
    minHeight: 'calc(100vh - 6em)',
  },
  heading: {
    color: '#0069cc',
    marginTop: '1em',
    textAlign: 'center',
  },
  table: {
    width: '100%',
    marginTop: '1em',
    border: '2px solid #0d58e6',
    borderCollapse: 'collapse',
  },
  th: {
    border: '1px solid #0d58e6',
    padding: '4px 6px',
    backgroundColor: '#cce6ff',
    fontWeight: 'bold',
    fontSize: '0.85em',
    textAlign: 'center',
  },
  td: {
    border: '1px solid #0d58e6',
    padding: '3px 6px',
    fontSize: '0.85em',
  },
};

export default PortfoliosPage;
